import { InvoiceStatus, TaxType } from "@/gql/graphql";

const status: {
  [key in InvoiceStatus]: string;
} = {
  [InvoiceStatus.Draft]: "Draft",
  [InvoiceStatus.Issued]: "Issued",
  [InvoiceStatus.Overdue]: "Overdue",
  [InvoiceStatus.Paid]: "Paid",
  [InvoiceStatus.Voided]: "Void",
};

const tax_type: {
  [key in TaxType]: string;
} = {
  [TaxType.Gst]: "GST",
  [TaxType.NoGst]: "No GST",
  [TaxType.Reimbursement]: "Reimbursement",
};

export const invoiceMessages = {
  tax_type,
  status,
  actions: {
    actions: "Actions",
    payOnline: "Pay online",
    addPayment: "Add payment",
    send: "Send",
    resend: "Resend",
    sendOverdueNotice: "Send overdue notice",
    invoiceSent: "Invoice sent",
    issue: "Issue",
    view: "View",
    pdf: "Pdf",
    void: "Void",
    delete: "Delete",
    deleteMessage: "Are you sure you want to delete this invoice",
    deleteTitle: "Delete invoice",
  },
  detail: {
    invoiceSummary: "Invoice Summary",
    amountDue: "Amount Due",
    due: "Due",
    overdue: "(overdue)",
    totalAmount: "Total Amount",
    amountPaid: "Amount Paid",
    refunded: "refunded",
    payOnline: "Pay Online",
    downloadPdf: "Download PDF",
    invoiceDetails: "Invoice Details",
    details: "Details",
    payee: "Payee",
    editPayee: "Edit payee",
    businessNumber: "Business Number",
    email: "Email",
    phone: "Phone",
    billingAddress: "Billing Address",
    poNumber: "Purchase Order #",
    invoiceDate: "Invoice Date",
    dueDate: "Due Date",
    lineItems: "Line items",
  },
};
